<template>
	<div>
		<div v-if="(leaderboard || []).length > 0">
			<v-layout d-flex justify-space-around pb-4>
				<v-layout
					v-for="(item, index) in getFirstThreeRank"
					:key="index"
					justify-end
					align-center
					column
					:style="[
						{
							order:
								(leaderboard || []).length > 2
									? index === 0
										? 15
										: index * 10
									: 1
						}
					]"
					style="flex: 1 !important"
				>
					<div
						class="outerCircle"
						:class="{
							darkBorder: item.retailerId === retailerId
						}"
					>
						<v-avatar :size="index === 0 ? '80' : '60'">
							<div
								class="imageCircle"
								:style="[
									{
										background: getHeadOnUserBackgroundColor(
											item.retailerId
										)
									}
								]"
							>
								{{ item.name.charAt(0).toUpperCase() || "-" }}
							</div>
						</v-avatar>
						<div class="smallCircle">{{ item.rank }}</div>
					</div>
					<div
						class="body-1 ellipsis text-center"
						style="width: 100%"
					>
						{{ item.name }}
					</div>
					<div
						class="caption ellipsis text-center"
						style="width: 100%"
					>
						{{ item.city }}
					</div>
					<div class="greenText">
						₹
						{{ item.gmv }}
					</div>
				</v-layout>
			</v-layout>
			<div class="scrollContainer" v-if="(prizes || []).length > 0">
				<template v-for="(prize, index) in prizes">
					<v-flex
						:key="index"
						class="prizeCard"
						:style="
							prizes.length > 1
								? { width: 'calc(95% - 16px)' }
								: { width: '100%' }
						"
						ma-2
						pa-3
					>
						<div class="prizeFirstText">
							{{ prize.rank }}
						</div>
						<div>
							<div class="prizeSecondText">
								{{ getOrdinalNumber(prize.rank) }}
							</div>
							<div class="prizeThirdText">Prize</div>
						</div>
						<div>
							<div class="prizeMainText">
								{{ prize.prize }}
							</div>
							<div class="prizeSubText">
								{{ prize.prizeText }}
							</div>
						</div>
					</v-flex>
				</template>
			</div>
			<div class="tableContainer aggregatedGmvTable">
				<div>
					<template
						v-for="(item, index) in aggregatedGmvFantasyRummy"
					>
						<v-expansion-panel :key="index">
							<v-expansion-panel-content>
								<template v-slot:header>
									<div class="aggregatedGmv">
										<div>
											Aggregated GMV
										</div>
										<div>₹ {{ aggregatedGmv }}</div>
									</div>
								</template>
								<v-data-table
									:headers="headers"
									class="elevation-1"
									:items="[item]"
									:hide-actions="true"
								>
									<template v-slot:items="props">
										<tr @click="props.expanded = true">
											<td class="text-xs-center">
												{{
													props.item
														.aggregatedGmvFantasyOffline
												}}
											</td>
											<td class="text-xs-center">
												{{
													Math.max(
														0,
														props.item
															.aggregatedGmvFantasyTotal -
															props.item
																.aggregatedGmvFantasyOffline
													)
												}}
											</td>
											<td class="text-xs-center">
												{{
													props.item
														.aggregatedGmvRummyOffline
												}}
											</td>
											<td class="text-xs-center">
												{{
													Math.max(
														0,
														props.item
															.aggregatedGmvRummyTotal -
															props.item
																.aggregatedGmvRummyOffline
													)
												}}
											</td>
											<td class="text-xs-center">
												{{
													props.item
														.aggregatedGmvLudoTotal
												}}
											</td>
										</tr>
									</template>
								</v-data-table>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</template>
				</div>
			</div>
			<div v-if="(leaderboard || []).length > 0" class="tableContainer">
				<div class="tableHeader">
					<div>Rank</div>
					<div>GMV</div>
				</div>
				<div v-if="getSelfEntry.length > 0" class="listEntry">
					<v-expansion-panel>
						<v-expansion-panel-content>
							<template v-slot:header>
								<div class="sideElement" />
								<div class="entryRank">
									{{ getSelfEntry[0].rank }}
								</div>
								<div class="entryImage">
									<v-avatar :size="50">
										<div
											class="imageCircle"
											:style="[
												{
													background: getHeadOnUserBackgroundColor(
														getSelfEntry[0]
															.retailerId
													)
												}
											]"
										>
											{{
												getSelfEntry[0].name.length > 0
													? getSelfEntry[0].name
															.charAt(0)
															.toUpperCase()
													: "-"
											}}
										</div>
									</v-avatar>
								</div>
								<div class="entryInfo">
									<div>
										<div>
											{{ getSelfEntry[0].name }}
										</div>
										<div>
											{{ getSelfEntry[0].city }}
										</div>
									</div>
									<div class="entryMoney">
										₹ {{ getSelfEntry[0].gmv }}
									</div>
								</div>
								<div class="sideElement right" />
							</template>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</div>
				<div>
					<template v-for="(item, index) in leaderboard">
						<v-expansion-panel :key="index">
							<v-expansion-panel-content>
								<template v-slot:header>
									<div
										v-if="item.retailerId !== retailerId"
										class="listEntry"
									>
										<div class="entryRank">
											{{ item.rank }}
										</div>
										<div class="entryImage">
											<v-avatar :size="50">
												<div
													class="imageCircle"
													:style="[
														{
															background: getHeadOnUserBackgroundColor(
																item.retailerId
															)
														}
													]"
												>
													{{
														(item.name || "-")
															.length > 0
															? item.name
																	.charAt(0)
																	.toUpperCase()
															: "-"
													}}
												</div>
											</v-avatar>
										</div>
										<div class="entryInfo">
											<div>
												<div>
													{{ item.name }}
												</div>
												<div>
													{{ item.city }}
												</div>
											</div>
											<div class="entryMoney">
												₹ {{ item.gmv }}
											</div>
										</div>
									</div>
								</template>
								<v-data-table
									:headers="headers"
									:items="[item]"
									class="elevation-1"
									:hide-actions="true"
								>
									<template v-slot:items="props">
										<tr @click="props.expanded = true">
											<td class="text-xs-center">
												{{
													props.item.gmvFantasyOffline
												}}
											</td>
											<td class="text-xs-center">
												{{
													Math.max(
														0,
														props.item
															.gmvFantasyTotal -
															props.item
																.gmvFantasyOffline
													)
												}}
											</td>
											<td class="text-xs-center">
												{{ props.item.gmvRummyOffline }}
											</td>
											<td class="text-xs-center">
												{{
													Math.max(
														0,
														props.item
															.gmvRummyTotal -
															props.item
																.gmvRummyOffline
													)
												}}
											</td>
											<td class="text-xs-center">
												{{ props.item.gmvLudoTotal }}
											</td>
										</tr>
									</template>
								</v-data-table>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getHeadOnUserBackgroundColor, getOrdinalNumber } from "../../utils";

export default {
	name: "Leaderboard",
	props: [
		"leaderboard",
		"prizes",
		"retailerId",
		"aggregatedGmv",
		"aggregatedGmvFantasyRummy"
	],
	data() {
		return {
			headers: [
				{
					text: "Fantasy Offline GMV",
					value: "gmvFantasyOffline",
					align: "center",
					sortable: false
				},
				{
					text: "Fantasy Online GMV",
					value: "gmvFantasyTotal",
					align: "center",
					sortable: false
				},
				{
					text: "Rummy Offline GMV",
					value: "gmvRummyOffline",
					align: "center",
					sortable: false
				},
				{
					text: "Rummy Online GMV",
					value: "gmvRummyTotal",
					align: "center",
					sortable: false
				},
				{
					text: "Ludo GMV",
					value: "gmvLudoTotal",
					align: "center",
					sortable: false
				}
			]
		};
	},
	computed: {
		getFirstThreeRank() {
			return (
				this.leaderboard.filter(user =>
					[1, 2, 3].includes(user.rank)
				) || []
			).sort((userA, userB) => {
				if (userA.rank < userB.rank) {
					return -1;
				} else if (userA.rank > userB.rank) {
					return 1;
				}
				return 0;
			});
		},
		getSelfEntry() {
			return (
				this.leaderboard.filter(
					user => user.retailerId === this.retailerId
				) || []
			);
		}
	},
	methods: {
		getOrdinalNumber(number) {
			return getOrdinalNumber(number);
		},
		getHeadOnUserBackgroundColor(userId) {
			return getHeadOnUserBackgroundColor(userId);
		}
	}
};
</script>

<style scoped lang="scss">
.imageCircle {
	width: 100%;
	height: 100%;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 20px;
}
.outerCircle {
	border-radius: 50%;
	border: 4px solid #e4f1ff;
	position: relative;
}
.outerCircle.darkBorder {
	border: 4px solid #205fb9;
}
.smallCircle {
	position: absolute;
	bottom: 0;
	right: 0;
	width: 20px;
	height: 20px;
	background: linear-gradient(180deg, #44bb70 0%, #0a8dd3 100%);
	border-radius: 50%;
	font-size: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-weight: 600;
}
.greenText {
	color: #44bb70;
	font-size: 16px;
	font-weight: 600;
}
.scrollContainer {
	max-width: 100%;
	display: flex;
	overflow: auto;
}
.prizeCard {
	background: #233b5d;
	box-shadow: 0px 0px 8px rgba(7, 28, 80, 0.1);
	border-radius: 4px;
	color: #c0c8d4;
	display: flex;
	align-items: center;
	flex-grow: 0;
	flex-shrink: 0;
}
.prizeFirstText {
	font-weight: 600;
	font-size: 33px;
	line-height: 140%;
	letter-spacing: 0.005em;
	color: #75efc6;
}
.prizeSecondText {
	font-size: 14px;
	color: #75efc6;
	line-height: 140%;
}
.prizeThirdText {
	font-size: 14px;
	line-height: 140%;
	color: #267fbf;
}
.prizeMainText {
	border-left: 1px solid #ccc;
	margin-left: 10px;
	padding-left: 10px;
	font-size: 16px;
}
.prizeSubText {
	border-left: 1px solid #ccc;
	margin-left: 10px;
	padding-left: 10px;
	font-size: 12px;
}
.tableContainer {
	box-shadow: 0px 0px 8px rgba(7, 28, 80, 0.1);
}
.tableHeader {
	background: #edf0f7;
	display: flex;
	justify-content: space-between;
	padding: 2px 6px;
	font-size: 12px;
	color: #7b899e;
}
.listEntry {
	display: flex;
	align-items: center;
	padding: 12px 8px 14px;
	border-bottom: 1px solid #ccc;
	position: relative;
}
.listEntry .sideElement {
	position: absolute;
	height: 100%;
	width: 5px;
	left: 0;
	top: 0;
	background: #205fb9;
}
.listEntry .sideElement.right {
	left: unset;
	right: 0;
}
.listEntry > div {
	display: flex;
	align-items: center;
}
.entryRank {
	flex: 0 1 calc(10% - 10px);
	justify-content: center;
	margin-right: 10px;
	font-size: 12px;
	color: #575f6b;
}
.entryImage {
	flex: 0 1 calc(40px - 10px);
	height: 30px;
	margin-right: 10px;
}
.entryInfo {
	flex: 0 1 calc(100% - 10% - 40px);
	display: flex;
	align-items: center;
	justify-content: space-between;
	& > div:first-child > div:first-child {
		color: #575f6b;
		font-size: 14px;
	}
	& > div:first-child > div:last-child {
		color: #828a97;
		font-size: 12px;
	}
}
.entryMoney {
	font-size: 12px;
	color: #575f6b;
	font-weight: 600;
	margin-right: 10px;
}
.aggregatedGmv {
	display: flex;
	justify-content: space-between;
}
.aggregatedGmvTable {
	margin-bottom: 10px;
	margin-top: 10px;
}
</style>
